module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_rogaland_pos.ab76a469.svg";